// Maps a backend error `code` to panel-owned ES copy for «Ampliar custodia». The rejection causes
// are exactly what the agent has to relay to the «Usuario» on the spot, and with fail-open
// eligibility gates those rejections WILL reach production — so the specific causes get their own
// sentence and only the unknown/absent case falls open to a generic. We never render the envelope's
// `message`/`detail` (untrusted backend string), nor the code itself.
// No `persistent` flag any more: every failure is reported through the floating notice, which stays
// up until the agent dismisses it (ADR 0021), so «does this one survive a timer» stopped being a
// property of the cause. Same shape as enableDeliveryError.

// TODO: i18n — copy en ES hasta Fase 1. «Empresa de mensajería», never «transportista»: the glossary
// deprecates the bare term as ambiguous between Carrier (the company, which this flag belongs to)
// and Courier (the person), and «empresa de mensajería» is the gloss it gives Carrier.
const SPECIFIC: Record<string, string> = {
  carrier_not_allowed: 'La empresa de mensajería de esta entrega no permite ampliar la custodia.',
  delivery_is_return: 'Es una devolución: no se puede ampliar el plazo de recogida.',
  expiration_date_too_far: 'La fecha excede el máximo de ampliación permitido.',
  delivery_state_conflict: 'La entrega ha cambiado de estado.',
  validation_error: 'La fecha no es válida.',
};

export function extendCustodyError(code: string | null): string {
  // Own-property only: the code is wire data, and a bare lookup also resolves inherited names, so a
  // `constructor` code would come back truthy and carry no readable message.
  const key = code?.toLowerCase() ?? '';
  const message = Object.hasOwn(SPECIFIC, key) ? SPECIFIC[key] : undefined;
  return message ?? 'No se pudo ampliar la custodia. Inténtalo de nuevo.'; // TODO: i18n
}
